<!-- 类似 足球世界杯 的赛程展示结果 -->
<template>
  <div
    class="matchItemRow"
    :class="themeClass === 'onlyDisplay' ? 'onlyDisplay' : ''"
  >
    <span class="item_matchLeft">
      <template
        v-if="
          ['scheduleNoticeFootballCup', 'scheduleNoticeThomasAndUber'].includes(
            viewMode
          ) && chooseState === 'choose'
        "
      >
        <span class="matchLeft_colum1">
          <span
            class="matchLeft_colum1_row1"
            v-text="
              _valPerFormatHandler(
                matchModeObj.type == 'matchDate'
                  ? item.stageNameWeb
                  : item.weekCN
              )
            "
          ></span>
          <span class="matchLeft_colum1_row2">
            <span
              class="matchItem_checkbox"
              v-for="channelItem in item.channelTvList"
              :class="channelItem.act ? 'act' : ''"
              :key="`${item.matchId}_${channelItem.value}`"
              @click.stop="matchItem_checkbox(item, channelItem)"
            >
              <span class="matchItem_channelItem" :class="channelType">
                <svg
                  t="1693726421166"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="21127"
                  width="80%"
                  height="80%"
                >
                  <path
                    d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
                    p-id="21128"
                  ></path>
                </svg>
              </span>
              <span
                class="matchItem_channelItem_text"
                v-text="channelItem.name"
              ></span>
            </span>
          </span>
        </span>
      </template>
      <template
        v-else-if="
          ['scheduleNoticeFootballCup', 'scheduleNoticeThomasAndUber'].includes(
            viewMode
          ) && themeClass === 'onlyDisplay'
        "
      >
        <span class="matchLeft_colum1">
          <span
            class="matchLeft_colum1_row1"
            v-text="
              _valPerFormatHandler(
                matchModeObj.type == 'matchDate'
                  ? item.stageNameWeb
                  : item.weekCN
              )
            "
          ></span>
          <span class="matchLeft_colum1_row2">
            <span
              class="matchItem_checkbox"
              v-for="channelItem in item.channels"
              :key="channelItem.channelId"
            >
              <span
                class="matchItem_channelItem_text channelName"
                v-text="channelItem.channelName"
              ></span>
            </span>
          </span>
        </span>
      </template>
      <template v-else>
        <span
          class="matchLeft_colum1"
          :class="matchModeObj.type"
          v-text="
            _valPerFormatHandler(
              matchModeObj.type == 'matchDate' ? item.stageNameWeb : item.weekCN
            )
          "
        ></span>
      </template>
    </span>

    <span class="item_matchCenter" v-if="matchStatusOpts">
      <span class="matchCenter_leftTeam">
        <span class="teamName" v-text="item.homeName"></span>
        <img v-if="item.homeLogo" :src="item.homeLogo" />
        <div v-else></div>
      </span>
      <span class="matchCenter_scoreArea">
        <span
          class="matchStatus_notStarted"
          v-if="
            item.matchStatus === matchStatusCode2CN.Fixture ||
            item.matchStatus === matchStatusCode2CN.Postponed
          "
          v-text="item.matchTime"
        ></span>
        <span
          v-else-if="
            item.matchStatus === matchStatusCode2CN.Playing ||
            item.matchStatus === matchStatusCode2CN.Suspended ||
            item.matchStatus === matchStatusCode2CN.Played
          "
          :class="[
            item.matchStatus == matchStatusCode2CN.Played
              ? 'matchStatus_over'
              : 'matchStatus_ongoing',
          ]"
        >
          <span v-text="item.homeScore"></span>
          <span v-text="item.awayScore"></span>
        </span>
        <span v-else></span>
      </span>
      <span class="matchCenter_rightTeam">
        <img v-if="item.awayLogo" :src="item.awayLogo" />
        <div v-else></div>
        <span class="teamName" v-text="item.awayName"></span>
      </span>
    </span>
    <span class="item_matchRight">
      <i class="matchRight_icon"></i>
      <span class="matchRight_text" v-text="item.venueName"></span>
    </span>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'FIFAWorldCup_matchItem',
  mixins: [cup_base_data_mixin],
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
    detailPathName: {
      type: [String, Array],
      default: '',
    },
    chooseState: {
      type: String,
      default: 'default', //['default', 'choose', 'none'] none：没有鼠标经过效果
    },
    localStorageName: {
      type: String,
      default: '',
    },
    localStorageSaveDate: {
      type: String,
      default: '',
    },
    themeClass: {
      // 不同页面视图的展示
      type: String,
      default: '',
    },
    viewMode: {
      // 相同页面，控制不同视图的展示;这个就是matchListViewMode中的元素
      type: String,
      default: '',
    },
    channelType: {
      type: String,
      default: 'radio', //频道选择的模式，radio:单选；checkbox:多选
    },
    matchStatusOpts: {
      type: [Object, null],
      default: null,
    },
    matchModeObj: {
      // 各个赛事都有赛程，但是也有互相复用的，因此抽离一个共用的赛程视图
      type: [Object, null],
      default: () => ({
        mode: '', //['compreSportsMeet', 'FIFAWorldCup']=['综合性赛事', '足球世界杯'|'世界杯亚洲预选赛', ]
        type: '',
        filterCondition: '',
        // any: xxx, 根据不同情况添加不同字段
      }),
    },
  },
  data() {
    return {}
  },
  computed: {
    matchStatusCode2CN() {
      let matchStatusCode2CN = {}
      if (this.matchStatusOpts && this.matchStatusOpts.matchStatusCode2CN) {
        matchStatusCode2CN = this.matchStatusOpts.matchStatusCode2CN
      }
      return matchStatusCode2CN
    },
  },
  methods: {
    // matchStatusToMatchCN(matchStatus, dataItem) {
    //   if (!this.matchStatusOpts) return
    //   const { apiVal2WebValMap, webValStyleArr } = this.matchStatusOpts
    //   let index = apiVal2WebValMap[matchStatus]
    //   let item = webValStyleArr[index]
    //   let matchCN = item.name[item.key.indexOf(matchStatus)]
    //   console.debug(
    //     'matchStatusToMatchCN:',
    //     matchStatus,
    //     index,
    //     item,
    //     item.key.indexOf(matchStatus),
    //     matchCN
    //   )
    //   if (item.colorClass === 'playing') {
    //     matchCN = `${this._valPerFormatHandler(
    //       dataItem.currentPeriodName
    //     )} ${this._valTimeFormatHandler(
    //       dataItem.timeMinutes
    //     )}:${this._valTimeFormatHandler(dataItem.timeSeconds)}`
    //   }
    //   return this._valPerFormatHandler(matchCN)
    // },
    // matchStatusClassName(item) {
    //   if (this.matchStatusOpts) {
    //     return ''
    //   } else {
    //     return this.matchStatusOpts.webValStyleArr[
    //       this.matchStatusOpts.apiVal2WebValMap[item.matchStatus]
    //     ].colorClass
    //   }
    // },
    matchItem_checkbox(matchItem, actItem) {
      this.$emit('clickMatchItemCheckboxItemEvent', {
        matchItem,
        actItem,
        type: this.channelType ? this.channelType : '',
      })
      console.debug('matchItem_checkbox')
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    _valTimeFormatHandler(val) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = '00'
      } else {
        if (val - 0 <= 9) {
          data = `0${val}`
        }
        data = val
      }
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.mixtmt_pc,
.mixtmt_ipad {
  .matchItemRow {
    position: relative;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    height: auto;
    width: 100%;
    padding: 0.694vw 1.388vw;
    color: var(--mixtmt_greyColor3);
    /* border-bottom: 1px solid var(--mixtmt_greyColor5); */
    transition: padding 0.3s linear;
    /* &.onlyDisplay {
      .item_matchLeft {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: 10.42vw;
        .matchLeft_colum1 {
          width: 100%;
        }
      }
      .item_matchCenter {
        width: calc(100% - 10.42vw - 6.94vw);
        .matchCenter_colum1 {
          width: 10.42vw;
        }
        .matchCenter_colum2 {
          width: calc(100% - 10.42vw);
        }
      }
    } */

    .matchLeft_colum1,
    .matchCenter_colum1,
    .matchCenter_colum2 {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      height: auto;
    }

    .matchLeft_colum1_row1 {
      margin-bottom: 0.347vw;
    }
    .item_matchLeft {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 20.83vw;
      .matchLeft_colum1 {
        width: 100%;
        .matchLeft_colum1_row1 {
          width: 100%;
          font-size: 1.11vw;
          line-height: 2.083vw;
          height: 2.083vw;
          /* font-weight: bold; */
        }
        .matchLeft_colum1_row2 {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          height: 2.083vw;
          font-size: 1.11vw;
          color: var(--mixtmt_greyColor2);
        }
      }
    }
    .item_matchCenter {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: 42.778vw;
      font-weight: bold;
      .matchCenter_scoreArea {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: 14.666vw;
        font-size: 1.11vw;
        .matchStatus_notStarted {
          width: 5.2vw;
          height: 2.5vw;
          background-color: var(--mixtmt_subColor1_1);
          color: var(--mixtmt_whiteColor);
          text-align: center;
          line-height: 2.5vw;
        }
        .matchStatus_ongoing,
        .matchStatus_over {
          position: relative;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          width: 7.2vw;
          height: 2.5vw;
          background-color: var(--mixtmt_mainColor8);
          color: var(--mixtmt_subColor_main);
          span {
            flex: 1;
            text-align: center;
          }
          &::before {
            content: '\20';
            position: absolute;
            top: 10%;
            left: 50%;
            z-index: 2;
            width: 1px;
            height: 80%;
            background-color: var(--mixtmt_subColor_main);
          }
        }
        .matchStatus_over {
          background-color: var(--mixtmt_subColor_main05);
          color: var(--mixtmt_greyColor_main);
        }
      }
      .matchCenter_leftTeam,
      .matchCenter_rightTeam {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: 14.056vw;
        img {
          display: block;
          width: 2.7vw;
          height: 1.8vw;
          overflow: hidden;
          object-fit: contain;
        }
        & > div{
          width: 2.7vw;
          height: 1.8vw;
          background-color: #efefef;
        }
        .teamName {
          width: calc(100% - 2.7vw);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .matchCenter_leftTeam {
        justify-content: flex-end;
        .teamName {
          padding-right: 0.7vw;
          text-align: right;
        }
      }
      .matchCenter_rightTeam {
        justify-content: flex-start;
        .teamName {
          padding-left: 0.7vw;
        }
      }
    }
    .item_matchLeft,
    .item_matchRight {
      flex: 1;
    }
    .item_matchRight {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      color: var(--mixtmt_greyColor2);
      .matchRight_icon {
        width: 1.042vw;
        height: 1.042vw;
        background-image: var(--mixtmt_scheduleMatchList_sportHall_icon);
        background-size: 100% auto;
        background-position: left top;
        background-repeat: no-repeat;
      }
      .matchRight_text {
        padding-left: 0.2778vw;
      }
    }

    .matchItem_checkbox {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: auto;
      margin-right: 0.974vw;
      .matchItem_channelItem {
        width: 1.11vw;
        height: 1.11vw;
        border-radius: 0.208vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        background-color: var(--mixtmt_whiteColor);
        &.radio {
          border-radius: 50%;
          border: 1px solid var(--mixtmt_greyColor2);
        }
        &.checkbox {
          border: 1px solid var(--mixtmt_greyColor2);
        }
        svg {
          opacity: 0;
          fill: var(--mixtmt_whiteColor);
          transition: all 0.3s linear;
        }
      }
      .matchItem_channelItem_text {
        padding: 0 0.374vw;
        font-size: 0.974vw;
        color: var(--mixtmt_greyColor2);
        &.channelName {
          padding: 0 0.374vw 0 0;
        }
      }
      &.act {
        .matchItem_channelItem {
          background-color: var(--mixtmt_scheduleItem_actSwitchColor);
          border: 1px solid var(--mixtmt_scheduleItem_actSwitchColor);
          svg {
            opacity: 1;
          }
        }
        .matchItem_channelItem_text {
          color: var(--mixtmt_scheduleItem_actSwitchColor);
          font-weight: bold;
        }
      }
    }
    .item_absChoose {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 0;
      height: 100%;
      transition: width 0.3s linear;
    }

    &.itemGreyColor {
      /* 赛程文字置灰，不可点击进入赛果 */
      /* color: var(--mixtmt_greyColor4); */
      opacity: 0.5;
    }
  }
}

.mixtmt_pc {
  .match_list_item:not(.none) {
    &:hover,
    &.choose.chooseAct {
      .matchItemRow {
        background-color: var(--mixtmt_scheduleItem_actBgColor);
        color: var(--mixtmt_whiteColor);
        .item_matchLeft {
          .matchLeft_colum1 {
            .matchLeft_colum1_row2 {
              color: var(--mixtmt_whiteColor);
              .matchItem_checkbox,
              .matchItem_channelItem_text.act {
                .matchItem_channelItem_text {
                  color: var(--mixtmt_whiteColor);
                }
              }
            }
          }
        }
        .item_matchCenter {
          .matchCenter_scoreArea {
            .matchStatus_notStarted {
              background-color: var(--mixtmt_whiteColor);
              color: var(--mixtmt_blackColor);
            }
            .matchStatus_ongoing,
            .matchStatus_over {
              background-color: var(--mixtmt_whiteColor);
              color: var(--mixtmt_blackColor);
              &::before {
                background-color: var(--mixtmt_greyColor0);
              }
            }
          }
        }
        .item_matchRight {
          color: var(--mixtmt_whiteColor);
        }
      }
    }
    &.choose.chooseAct,
    &.choose,
    &.default {
      cursor: pointer;
    }
  }
}
</style>
